"use client";

import Script from "next/script";
import { useTrackingConsent } from "@/lib/consent/use-tracking-consent";
import { GOOGLE_TAG_MANAGER } from "@/lib/analytics/config";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default function GTMTracker() {
  const allowed = useTrackingConsent();

  return (
    <>
      {/* Google Tag Manager Script - Loads AFTER consent defaults */}
      {allowed && (
        <Script
          id="gtm-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: /* js */ `
            // Never load GTM on a loopback host: doing so sends local
            // development hits into the production GA4 property, where they
            // inflate sessions, skew engagement metrics and pollute reporting.
            (function () {
            if (!window.privacyConsent?.allowed) return;
            if (/^(localhost|127(?:\.\d{1,3}){3}|\[::1\]|0\.0\.0\.0)$/.test(window.location.hostname)) {
              console.log("GTM: Skipped — loopback hostname, no analytics sent");
            } else {
              (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                // Cloudflare's Google tag gateway inserts its own loader, <script src="/0pjy/">,
                // at the top of normal pages. It loads this same container but never pushes
                // gtm.js, so the push above is what starts the tags (after the consent
                // defaults, which run beforeInteractive). Downloading the container again would
                // fetch ~440 KB twice for nothing — the same rule as maliqe-website.
                if (d.querySelector('script[src="${GOOGLE_TAG_MANAGER.GATEWAY_PATH}"]')) return;
                var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != "dataLayer" ? "&l=" + l : "";
                j.async = true;
                // Pages the gateway didn't touch (e.g. 404s): load the container through the
                // gateway path anyway, so hits still go first-party. If that fails, fall back to
                // Google's own URL so measurement degrades rather than stopping.
                j.src = "${GOOGLE_TAG_MANAGER.GATEWAY_PATH}?id=" + i + dl;
                j.onerror = function () {
                  console.warn("GTM: gateway path failed, loading from googletagmanager.com");
                  var k = d.createElement(s);
                  k.async = true;
                  k.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                  f.parentNode.insertBefore(k, f);
                };
                f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer", "${GOOGLE_TAG_MANAGER.CONTAINER_ID}");

              console.log("GTM: Container loaded");
            }
            })();
          `,
          }}
        />
      )}

      {/* Optional tracking is never loaded without JavaScript consent resolution. */}
    </>
  );
}
